/**
 * @generated SignedSource<<8c1ac9fe37d4e02c6c81b594e79ff041>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarousel_user";
};
export type HpSharedFeaturedModuleCarousel_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "340ad3f3bab2d0365b78b7b2cbce1534";

export default node;
